<template>
    <div v-if="!$isSubAgentUser">
        <el-row>
            <el-collapse v-model="activemenu"
                         accordion>
                <el-collapse-item name="1"
                                  :loading="loading">
                    <template slot="title">
                        <h2 style="text-align: center;">{{$t('dashboard.claims')}}</h2>
                    </template>
                    <el-row>
                        <el-col :span="5">
                            <div class="toolbar">
                                <el-select @change="chooseAction($event)"
                                           @clear="filterClaimClear"
                                           value=""
                                           filterable
                                           remote
                                           reserve-keyword
                                           :placeholder="$t('dashboard.searchForClaimByNumber')"
                                           :title="$t('dashboard.searchForClaimByNumber')"
                                           :remote-method="searchForClaims"
                                           :loading="claimsLoading">
                                    <el-option v-for="item in foundClaims"
                                               :key="item.id"
                                               :label="item.claimNumber + ' (' + item.status + ')' + ' by ' + item.raisedBy"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="claimsCategories1"
                                          :show-header="false"
                                          @row-click="goToClaimCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="35"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="claimsCategories2"
                                          :show-header="false"
                                          @row-click="goToClaimCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="35"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="claimsCategories3"
                                          :show-header="false"
                                          @row-click="goToClaimCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="45"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="claimsCategories4"
                                          :show-header="false"
                                          @row-click="goToClaimCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="45"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <h3></h3>
                        <el-table size="mini"
                                  :data="claims"
                                  v-loading="loading"
                                  class="claims-table tablewithshading">
                            <el-table-column prop="claimNumber"
                                             :label="$t('common.claimNumber')"></el-table-column>
                            <el-table-column prop="workOrder"
                                             :label="$t('common.workOrder')"></el-table-column>
                            <el-table-column prop="invoiceNumber"
                                             :label="$t('common.invoiceNumber')"></el-table-column>
                            <el-table-column prop="status"
                                             :label="$t('common.status')"></el-table-column>
                            <el-table-column :label="$t('dashboard.date')">
                                <template slot-scope="scope">
                                    {{scope.row.raisedOn | date }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="$isFullAdmin ? $t('dashboard.operations') : $t('dashboard.view')"
                                             fixed="right"
                                             width="220">
                                <template slot-scope="scope">
                                    <el-button size="mini"
                                               @click="viewClaim(scope.row.id)">
                                        <i class="el-icon-view"></i>
                                    </el-button>
                                    <el-button size="mini"
                                               @click="editClaim(scope.row.id)"
                                               v-if="scope.row.status == 'Partial' || scope.row.status == 'MoreInformationRequired'">
                                        <i class="el-icon-edit"></i>
                                    </el-button>
                                    <el-button size="mini"
                                               type="danger"
                                               @click="deleteClaim(scope.row.id)"
                                               v-if="scope.row.status == 'Partial'">
                                        <i class="el-icon-delete"></i>
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>

                    <el-pagination class="pager"
                                   @current-change="handleClaimPageChange"
                                   :current-page.sync="claimsPage"
                                   :page-size="15"
                                   layout="total, prev, pager, next"
                                   :total="claimsTotal">
                    </el-pagination>
                </el-collapse-item>
                <el-collapse-item name="2"
                                  :loading="loading"
                                  v-if="$isAdmin">
                    <template slot="title">
                        <h2 style="text-align: center;">{{$t('dashboard.serviceTickets')}}</h2>
                    </template>
                    <el-col :span="6">
                        <div class="toolbar">
                            <el-select @change="viewServiceTicket($event)"
                                       @clear="filterServiceTicketClear"
                                       value=""
                                       filterable
                                       remote
                                       reserve-keyword
                                       :placeholder="$t('dashboard.searchServiceTicketByNumberOrCustomer')"
                                       :title="$t('dashboard.searchServiceTicketByNumberOrCustomer')"
                                       :remote-method="searchForServiceTickets"
                                       :loading="serviceTicketsLoading"
                                       style="width: 250px;">
                                <el-option v-for="item in foundServiceTickets"
                                           :key="item.id"
                                           :label="item.serialNumber + ' (' + item.status + ')' + ' by ' + item.openedBy"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div>
                            <el-table size="mini"
                                      style="cursor: pointer;"
                                      :data="serviceTicketsCategories1"
                                      :show-header="false"
                                      @row-click="goToServiceTicketsCategory"
                                      class="claims-table">
                                <el-table-column prop="total"
                                                 width="35"></el-table-column>
                                <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                <el-table-column v-else prop="nameFr"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div>
                            <el-table size="mini"
                                      style="cursor: pointer;"
                                      :data="serviceTicketsCategories2"
                                      :show-header="false"
                                      @row-click="goToServiceTicketsCategory"
                                      class="claims-table tablewithshading">
                                <el-table-column prop="total"
                                                 width="35"></el-table-column>
                                <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                <el-table-column v-else prop="nameFr"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div>
                            <el-table size="mini"
                                      style="cursor: pointer;"
                                      :data="serviceTicketsCategories3"
                                      :show-header="false"
                                      @row-click="goToServiceTicketsCategory"
                                      class="claims-table">
                                <el-table-column prop="total"
                                                 width="45"></el-table-column>
                                <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                <el-table-column v-else prop="nameFr"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div>
                            <el-table size="mini"
                                      style="cursor: pointer;"
                                      :data="serviceTicketsCategories4"
                                      :show-header="false"
                                      @row-click="goToServiceTicketsCategory"
                                      class="claims-table">
                                <el-table-column prop="total"
                                                 width="45"></el-table-column>
                                <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                <el-table-column v-else prop="nameFr"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-collapse-item>
                <el-collapse-item name="3"
                                  :title="$t('common.partOrders')"
                                  :loading="loading">
                    <template slot="title">
                        <h2 style="text-align: center;">{{$t('common.partOrders')}}</h2>
                    </template>
                    <el-row>
                        <el-col :span="8">
                            <div class="toolbar">
                                <el-select @change="viewOrder($event)"
                                           @clear="filterPartClear"
                                           value=""
                                           filterable
                                           remote
                                           reserve-keyword
                                           :placeholder="$t('dashboard.searchForPartByNumberOrServiceCompanyName')"
                                           :title="$t('dashboard.searchForPartByNumberOrServiceCompanyName')"
                                           :remote-method="searchForParts"
                                           :loading="partsLoading"
                                           style="width:100%;">
                                    <el-option v-for="item in foundParts"
                                               :key="item.id"
                                               :label="item.serviceWorkOrder + ' (' + item.status + ')' + ' by ' + item.serviceCompany"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="partOrdersCategories1"
                                          :show-header="false"
                                          @row-click="goToPartOrdersCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="35"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="partOrdersCategories2"
                                          :show-header="false"
                                          @row-click="goToPartOrdersCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="35"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="partOrdersCategories3"
                                          :show-header="false"
                                          @row-click="goToPartOrdersCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="45"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div>
                                <el-table size="mini"
                                          style="cursor: pointer;"
                                          :data="partOrdersCategories4"
                                          :show-header="false"
                                          @row-click="goToPartOrdersCategory"
                                          class="claims-table">
                                    <el-table-column prop="total"
                                                     width="45"></el-table-column>
                                    <el-table-column v-if="$i18n.locale == 'en'" prop="name"></el-table-column>
                                    <el-table-column v-else prop="nameFr"></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <h3>{{$t('dashboard.activeOrders')}}</h3>
                        <el-table size="mini"
                                  :data="orders"
                                  v-loading="loading"
                                  class="claims-table tablewithshading">
                            <el-table-column prop="serviceWorkOrder"
                                             :label="$t('dashboard.salesOrder')"></el-table-column>
                            <el-table-column prop="purchaseOrderNumber"
                                             :label="$t('dashboard.purchaseOrderNumber')"></el-table-column>
                            <el-table-column prop="shippingMethod"
                                             :label="$t('dashboard.shipping')"></el-table-column>
                            <el-table-column prop="status"
                                             :label="$t('common.status')"></el-table-column>
                            <el-table-column :label="$t('dashboard.date')">
                                <template slot-scope="scope">
                                    {{scope.row.placedAt | date }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="$isFullAdmin ? $t('dashboard.operations') : $t('dashboard.view')"
                                             fixed="right"
                                             width="160">
                                <template slot-scope="scope">
                                    <el-button size="mini"
                                               @click="viewOrder(scope.row.id)">
                                        <i class="el-icon-view"></i>
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    <el-pagination class="pager"
                                   @current-change="handleOrderPageChange"
                                   :current-page.sync="ordersPage"
                                   :page-size="15"
                                   layout="total, prev, pager, next"
                                   :total="ordersTotal">
                    </el-pagination>
                </el-collapse-item>
                <el-collapse-item name="4"
                                  :loading="loading">
                    <template slot="title">
                        <h2 style="text-align: center;">R&D RMAs</h2>
                    </template>
                    <el-row>
                        <el-col :span="5">
                            <div class="toolbar">
                                <el-select @change="viewRMA($event)"
                                           @clear="filterRMAClear"
                                           value=""
                                           filterable
                                           remote
                                           reserve-keyword
                                           :placeholder="$t('dashboard.searchForRMAByNumber')"
                                           :title="$t('dashboard.searchForRMAByNumber')"
                                           :remote-method="searchForRMAs"
                                           :loading="rmasLoading">
                                    <el-option v-for="item in foundRMAs"
                                               :key="item.id"
                                               :label="'RMA: ' + item.id + ' (Claim: ' + item.claimId + ')' + ' Invoice: ' + item.invoiceNumber"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <h3></h3>
                        <el-table size="mini"
                                  :data="rmas"
                                  v-loading="loading"
                                  class="claims-table tablewithshading">
                            <el-table-column prop="rmaNumber"
                                             label="RMA #"></el-table-column>
                            <el-table-column :label="$t('common.rmaCreationDate')">
                                <template slot-scope="scope">
                                    {{scope.row.rmaDate | date }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="requestor"
                                             :label="$t('dashboard.rmaRequestor')"></el-table-column>
                            <el-table-column prop="partNumber"
                                             :label="$t('common.partNum')"></el-table-column>
                            <el-table-column prop="serviceCompany"
                                             :label="$t('common.serviceCompany')"></el-table-column>
                            <el-table-column prop="claimNumber"
                                             :label="$t('dashboard.claimNum')"></el-table-column>
                            <el-table-column prop="modelNumber"
                                             label="$t('common.modelNum')"></el-table-column>
                            <el-table-column :label="$isFullAdmin ? $t('dashboard.operations') : $t('dashboard.view')"
                                             fixed="right"
                                             width="220">
                                <template slot-scope="scope">
                                    <el-button size="mini"
                                               @click="viewRMA(scope.row.rmaNumber)">
                                        <i class="el-icon-view"></i>
                                    </el-button>
                                    <el-button size="mini"
                                               @click="editRMA(scope.row.rmaNumber)">
                                        <i class="el-icon-edit"></i>
                                    </el-button>
                                    <el-button size="mini"
                                               type="danger"
                                               @click="deleteRMA(scope.row.rmaNumber)">
                                        <i class="el-icon-delete"></i>
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-row>
        <create-update-claim-dialog :claimId="claimToEdit"
                                    :visible="updateClaimVisible"
                                    @dialogClosed="updateClaimFinished"
                                    @showClaimPreview="showClaimPreview"
                                    @showClaimConfirm="showClaimConfirm"
                                    @previewClaim="viewClaim"></create-update-claim-dialog>
        <preview-claim-dialog :claimId="claimToView"
                              :visible="previewClaimVisible"
                              :isForPartial="isForPartial"
                              @dialogClosed="previewClaimFinished"
                              @editClaim="editClaim"
                              @claimPublished="claimPublished"
                              @statusChanged="statusChanged"></preview-claim-dialog>
        <create-update-part-order-dialog :visible="orderDialogVisible"
                                         :orderId="orderToView"
                                         @dialogClosed="viewOrderFinished"
                                         :save="loadOrders"></create-update-part-order-dialog>
        <service-ticket-details-dialog :visible="serviceTicketDialogVisible"
                                       :ticketId="ticketToEdit"
                                       @dialogClosed="serviceTicketViewFinished"></service-ticket-details-dialog>
        <create-update-rma-dialog :rmaId="rmaToEdit"
                                  :visible="updateRMAVisible"
                                  @dialogClosed="updateRMAFinished"
                                  :save="loadRMAs"></create-update-rma-dialog>
        <preview-rma-dialog :rmaId="rmaToView"
                            :visible="previewRMAVisible"
                            @dialogClosed="previewRMAFinished"></preview-rma-dialog>
        <el-dialog :title="$t('common.pleaseChoose')"
                   :visible.sync="chooseActionVisible"
                   width="30%">
            <span>{{$t('common.whatYouWantToDo')}}</span>
            <span slot="footer"
                  class="dialog-footer">
                <el-button type="primary"
                           @click="editClaim(claimId)"
                           :style="{visibility: isUserHardt ? 'visible' : 'hidden'}">{{$t('common.edit')}}</el-button>
                <el-button type="primary"
                           @click="viewClaim(claimId)">{{$t('common.view')}}</el-button>
                <el-button @click="chooseActionVisible = false">{{$t('common.nothing')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import CreateUpdateClaimDialog from "@/app/claims/components/CreateUpdateClaimDialog";
    import CreateUpdatePartOrderDialog from "@/app/orders/components/CreateUpdatePartOrderDialog";
    import PreviewClaimDialog from "@/app/claims/components/PreviewClaimDialog";
    import ServiceTicketDetailsDialog from "@/app/servicetickets/components/ServiceTicketDetailsDialog";
    import SendEmailDialog from "@/app/servicetickets/components/SendEmailDialog";
    import CreateUpdateRmaDialog from "@/app/rma/components/CreateUpdateRma";
    import PreviewRmaDialog from "@/app/rma/components/PreviewRmaDialog";

    import { EventBus } from "@/app/event-bus.js";
    import api from "../api";

    export default {
        name: "dasboard",
        components: {
            CreateUpdateClaimDialog,
            CreateUpdatePartOrderDialog,
            PreviewClaimDialog,
            ServiceTicketDetailsDialog,
            SendEmailDialog,
            CreateUpdateRmaDialog,
            PreviewRmaDialog
        },
        data() {
            return {
                loading: false,
                claimId: 0,
                chooseActionVisible: false,
                isForPartial: false,
                isUserHardt: false,
                claimsLoading: false,
                foundClaims: [],
                claimToView: undefined,
                claimToEdit: undefined,
                updateClaimVisible: false,
                previewClaimVisible: false,
                claims: [],
                claimsPage: 1,
                claimsTotal: 0,

                partsLoading: false,
                foundParts: [],
                orderToView: undefined,
                orderDialogVisible: false,
                orders: [],
                ordersPage: 1,
                ordersTotal: 0,

                ticketToEdit: null,
                serviceTicketsLoading: false,
                serviceTicketDialogVisible: false,
                foundServiceTickets: [],

                claimsCategories1: [],
                claimsCategories2: [],
                claimsCategories3: [],
                claimsCategories4: [],

                serviceTicketsCategories1: [],
                serviceTicketsCategories2: [],
                serviceTicketsCategories3: [],
                serviceTicketsCategories4: [],

                partOrdersCategories1: [],
                partOrdersCategories2: [],
                partOrdersCategories3: [],
                partOrdersCategories4: [],

                activemenu: "1",

                rmas: [],
                rmasTotal: 0,
                rmaToEdit: null,
                rmasLoading: false,
                foundRMAs: [],
                updateRMAVisible: false,
                previewRMAVisible: false,
                rmaToView: null
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    this.loadClaims();
                    this.loadOrders();
                    this.loadClaimsCategories();
                    this.loadServiceTicketsCategories();
                    this.loadPartOrdersCategories();
                }
            }
        },
        created() {
            this.loadClaims();
            this.loadOrders();
            this.loadClaimsCategories();
            this.loadServiceTicketsCategories();
            this.loadPartOrdersCategories();
            this.loadRMAs();
        },
        mounted() {
            var self = this;
            EventBus.$on("order-placed", order => {
                this.loadPartOrdersCategories();
                this.loadOrders();
            });
            EventBus.$on("claim-created", () => {
                this.loadClaimsCategories();
                this.loadClaims();
            });
            EventBus.$on("showClaimConfirm", claimId => {
                this.showClaimConfirm(claimId);
            });
        },
        beforeDestroy() {
            EventBus.$off("order-placed");
            EventBus.$off("claim-created");
            EventBus.$off("showClaimConfirm");
        },
        methods: {
            searchForClaims(term) {
                this.claimsLoading = true;
                api.getClaimsForSearch(term).then(
                    response => {
                        this.foundClaims = response.data.items;
                        this.claimsLoading = false;
                    },
                    () => {
                        this.claimsLoading = false;
                    }
                );
            },
            searchForParts(term) {
                this.partsLoading = true;
                api.getPartsForSearch(term).then(
                    response => {
                        this.foundParts = response.data.items;
                        this.partsLoading = false;
                    },
                    () => {
                        this.partsLoading = false;
                    }
                );
            },
            searchForServiceTickets(term) {
                this.serviceTicketsLoading = true;
                api.getServiceTicketsForSearch(term).then(
                    response => {
                        this.foundServiceTickets = response.data.items;
                        this.serviceTicketsLoading = false;
                    },
                    () => {
                        this.serviceTicketsLoading = false;
                    }
                );
            },
            searchForRMAs(term) {
                this.rmasLoading = true;
                api.getRMAsForSearch(term).then(
                    response => {
                        this.foundRMAs = response.data.items;
                        this.rmasLoading = false;
                    },
                    () => {
                        this.rmasLoading = false;
                    }
                );
            },
            filterClaimClear() {
                this.claimsLoading = false;
                this.foundClaims = [];
            },
            filterPartClear() {
                this.partsLoading = false;
                this.foundParts = [];
            },
            filterServiceTicketClear() {
                this.serviceTicketsLoading = false;
                this.foundServiceTickets = [];
            },
            filterRMAClear() {
                this.rmasLoading = false;
                this.foundRMAs = [];
            },
            chooseAction(id) {
                this.isUserHardt = this.$currentUser.profile.role == "admin";
                this.claimId = id;
                this.chooseActionVisible = true;
            },
            viewClaim(id) {
                if (this.chooseActionVisible == true) {
                    this.chooseActionVisible = false;
                }
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            viewServiceTicket(id) {
                this.ticketToEdit = id;
                this.serviceTicketDialogVisible = true;
            },
            viewRMA(id) {
                this.rmaToView = id;
                this.previewRMAVisible = true;
            },
            editClaim(id) {
                if (this.chooseActionVisible == true) {
                    this.chooseActionVisible = false;
                }
                this.claimToEdit = id;
                this.updateClaimVisible = true;
            },
            showClaimPreview(id) {
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            showClaimConfirm(id) {
                this.claimToView = id;
                this.isForPartial = true;
                this.previewClaimVisible = true;
            },
            updateClaimFinished() {
                this.claimToEdit = undefined;
                this.updateClaimVisible = false;
                this.filterClaimClear();
            },
            previewClaimFinished() {
                this.claimToView = undefined;
                this.previewClaimVisible = false;
                this.isForPartial = false;
                this.filterClaimClear();
            },
            serviceTicketViewFinished() {
                this.ticketToEdit = null;
                this.dialogVisible = false;
            },
            viewOrder(id) {
                this.orderToView = id;
                this.orderDialogVisible = true;
            },
            viewOrderFinished() {
                this.orderToView = undefined;
                this.orderDialogVisible = false;
            },
            loadClaims() {
                this.loading = true;
                api.getClaims(this.claimsPage).then(response => {
                    this.loading = false;
                    this.claims = response.data.items;
                    this.claimsTotal = response.data.total;
                });
            },
            loadOrders() {
                this.loading = true;
                api.getOrders(this.ordersPage).then(response => {
                    this.loading = false;
                    this.orders = response.data.items;
                    this.ordersTotal = response.data.total;
                });
            },
            loadRMAs() {
                this.loading = true;
                api.getRMAs(this.ordersPage).then(response => {
                    this.loading = false;
                    this.rmas = response.data.items;
                    this.rmasTotal = response.data.total;
                });
            },
            loadClaimsCategories() {
                this.loading = true;
                api.getClaimsCategories().then(response => {
                    this.loading = false;
                    this.claimsCategories1 = response.data.splice(0, 2);
                    this.claimsCategories2 = response.data.splice(0, 2);
                    this.claimsCategories3 = response.data.splice(0, 2);
                    this.claimsCategories4 = response.data.splice(0, 2);
                });
            },
            loadServiceTicketsCategories() {
                this.loading = true;
                api.getServiceTicketsCategories().then(response => {
                    this.loading = false;
                    this.serviceTicketsCategories1 = response.data.splice(0, 2);
                    this.serviceTicketsCategories2 = response.data.splice(0, 2);
                    this.serviceTicketsCategories3 = response.data.splice(0, 2);
                    this.serviceTicketsCategories4 = response.data.splice(0, 2);
                });
            },
            loadPartOrdersCategories() {
                this.loading = true;
                api.getPartOrdersCategories().then(response => {
                    this.loading = false;
                    this.partOrdersCategories1 = response.data.splice(0, 1);
                    this.partOrdersCategories2 = response.data.splice(0, 1);
                    this.partOrdersCategories3 = response.data.splice(0, 1);
                    this.partOrdersCategories4 = response.data.splice(0, 1);
                });
            },
            handleClaimPageChange(page) {
                this.claimsPage = page;
                this.loadClaims();
            },
            handleOrderPageChange(page) {
                this.ordersPage = page;
                this.loadOrders();
            },
            goToClaimCategory(event) {
                window.location.href = "/#/claims/" + event.status;
            },
            goToServiceTicketsCategory(event) {
                window.location.href = "/#/service-tickets/" + event.status;
            },
            goToPartOrdersCategory(event) {
                window.location.href = "/#/part-orders/" + event.status;
            },
            statusChanged() {
                this.loadClaims();
            },
            claimPublished() {
                this.$notify({
                    title: this.$t('common.success'),
                    message: this.$t('common.claimSuccesfullySubmitted'),
                    type: "success"
                });
                this.loadClaims();
            },
            deleteClaim(id) {
                this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteClaim(id).then(() => {
                            this.loadClaims();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            editRMA(id) {
                if (this.previewRMAVisible == true) {
                    this.previewRMAVisible = false;
                }
                this.rmaToEdit = id;
                this.updateRMAVisible = true;
            },
            deleteRMA(id) {
                this.$confirm(this.$t('common.thisWillDeleteRMAContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteRMA(id).then(() => {
                            this.loadRMAs();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            updateRMAFinished() {
                this.rmaToEdit = undefined;
                this.updateRMAVisible = false;
                this.filterRMAClear();
            },
            previewRMAFinished() {
                this.rmaToView = undefined;
                this.previewRMAVisible = false;
                this.filterRMAClear();
            },
        }
    };
</script>

<style scoped>
    .toolbar {
        width: 400px;
    }

    tr > td {
        padding: 0;
    }
</style>
<style>
    .el-table--scrollable-x .el-table__body-wrapper {
        overflow-x: hidden;
    }

    .el-collapse .el-table .cell,
    .el-table th div {
        padding-right: 0;
        padding-left: 0;
        word-break: break-word;
    }

    .el-collapse-item__header {
        border-bottom: 1px solid #af064e;
    }

    .el-collapse-item__wrap {
        border-bottom: 1px solid #af064e;
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/dashboard/components/Dashboard.vue